import { List } from 'immutable';

export class Page<T> {
  content: List<T>;
  number: number;
  size: number;
  totalElements: number;
  totalPages: number;
  sort: List<Object>;

  static empty<T>(): Page<T> {
    let pageObj = new Page<T>();
    pageObj.content = List<T>();
    pageObj.number = 0;
    pageObj.size = 25;
    pageObj.totalElements = 0;
    pageObj.totalPages = 0;
    pageObj.sort = List<Object>();

    return pageObj;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/shared/models/page.ts